import React from 'react';
import ReactPlayer from 'react-player';
import './Content.css';
import Left from '../Left/Left';


function Content() {
    return (
        <>
         <div className="content_container">
             <div className="left_container">
             <div className="left_top_container">
              
              
                <Left/> 
             </div>
             <div className="left_bottom_container">
                 <img src="./student_content_corner_image.jpg" alt="no image found
                " />
             </div>

             </div>
             <div className="right_container">

             <div className="video_heading">
                1.1 Welcome to this Course
             </div>
               
               <ReactPlayer className="video_link" url="https://youtu.be/-LFKE8x8L-Q"/>
               <div className="change_options">
                   <div className="previous_option"> &lt; Previous</div>
                   <div className="next_option"> Next &gt;</div>
               </div>
             </div>

         </div>   
        </>
    )
}

export default Content
